import React from "react";
import Symbol from "./Symbol";
import styled from "styled-components";
const Selector = (props) => {
    return (React.createElement(Wrapper, null,
        React.createElement(Table, null, props.symbols.map((symbol) => (React.createElement(Symbol, { key: `${symbol.symbol}-${symbol.description}-${symbol.type}-${symbol.exchange}`, symbol: symbol, callback: props.callback }))))));
};
const Wrapper = styled.div `
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;

  ::-webkit-scrollbar {
    width: 0px;
  }
`;
const Table = styled.table `
  width: 100%;
  border-spacing: 0px;
`;
export default Selector;
//# sourceMappingURL=index.js.map